import { useCallback, useState } from 'react';
import { writeText } from 'clipboard-polyfill';
import { translate } from '@chaika/i18n/helper';

interface UsePolicyNumberCopyData {
    copyTitle: string;
    onCopyClick(): void;
}

/**
 * Copies text to clipboard. Best to use with Tooltip
 * @param textToCopy Text that will be copied to clipboard
 * @param defaultTextOptional Initial title for Tooltip
 * @param copiedTextOptional Title for Tooltip that will be shown after handler use for _delay_ time
 * @param delay Delay time
 * @returns copyTitle - Title for Tooltip, onCopyClick - handler for button
 */
export function useCopyToClipboard(
    textToCopy: string,
    defaultTextOptional?: string,
    copiedTextOptional?: string,
    delay: number = 1000,
): UsePolicyNumberCopyData {
    const defaultText = defaultTextOptional ?? translate('copyToClipboard');
    const copiedText = copiedTextOptional ?? translate('copied');
    const [copyTitle, setCopyTitle] = useState(defaultText);

    const onCopyClick = useCallback(() => {
        writeText(textToCopy);
        setCopyTitle(copiedText);
        setTimeout(() => setCopyTitle(defaultText), delay);
    }, [textToCopy, defaultText, copiedText, delay]);

    return {
        copyTitle,
        onCopyClick,
    };
}
